import { render, staticRenderFns } from "./ModalSelecionarDadosCpfCnpj.vue?vue&type=template&id=0b4d8cc4&scoped=true&lang=pug"
import script from "./ModalSelecionarDadosCpfCnpj.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarDadosCpfCnpj.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarDadosCpfCnpj.vue?vue&type=style&index=0&id=0b4d8cc4&prod&lang=scss&scoped=true"
import style1 from "./ModalSelecionarDadosCpfCnpj.vue?vue&type=style&index=1&id=0b4d8cc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d8cc4",
  null
  
)

export default component.exports